import { defineAgenda, param } from '@/shared/navigation/core';
import { columbusDetailAgenda } from './columbusDetailAgenda';

export const columbusAgenda = defineAgenda({
  id: 'app.columbus-planner',
  path: 'app/columbus-planner',
  open: {},
  state: {
    activeNodeId: param.string().optional(),
    transportType: param.enum(['Air', 'Bus'] as const).optional(),
    includeHistory: param.boolean().optional(),
  },
  title: 'Yield & Ticketing',
  icon: 'map',
  presentationHints: {
    shell: {
      layoutMode: 'list-detail',
      detailAgendaAllowlist: [columbusDetailAgenda.id],
    },
  },
});
